import { RoleType } from '@bmwe/data/kwg/graphql';

export const ROLE_HIERARCHY: Record<RoleType, number> = {
  [RoleType.Reader]: 1,
  [RoleType.Contributor]: 2,
  [RoleType.Editor]: 3,
  [RoleType.Administrator]: 4,
} as const;

/**
 * Checks if a user's role satisfies the minimum required role based on hierarchy.
 *
 * @param userRole - The role the user has
 * @param requiredRole - The minimum required role
 * @returns true if the user's role is equal to or higher than the required role
 *
 * @example
 * isRoleSufficient(RoleType.Editor, RoleType.Reader) // true
 * isRoleSufficient(RoleType.Reader, RoleType.Editor) // false
 */
export function isRoleSufficient(
  userRole: RoleType,
  requiredRole: RoleType,
): boolean {
  return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[requiredRole];
}
